import { render, staticRenderFns } from "./TestItem.vue?vue&type=template&id=7e10a022&scoped=true&"
import script from "./TestItem.vue?vue&type=script&lang=js&"
export * from "./TestItem.vue?vue&type=script&lang=js&"
import style0 from "./TestItem.vue?vue&type=style&index=0&id=7e10a022&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e10a022",
  null
  
)

export default component.exports